export enum IceHockeyGoalAttribute {
  PenaltyGoal = 491,
  PowerPlay = 394,
  Shorthanded = 395,
  EmptyNet = 396,
  EvenStrength = 797,
  HighDangerRangeGoal = 798,
  MidRangeGoal = 799,
  LongRangeGoal = 800,
  BehindTheNet = 801,
  BehindTheBlueLine = 802,
  UpperLeftGoals = 803,
  UpperRightGoals = 804,
  UpperMiddleGoals = 805,
  BottomMiddleGoals = 806,
  BottomRightGoals = 807,
  BottomLeftGoals = 808,
  Snap = 978,
  Slap = 979,
  Wrist = 980,
  TipIn = 981,
  Backhand = 982,
  Shovel = 983,
  OneHanded = 984,
  WrapAround = 985,
}
